import instanciaAxios from './InterceptorAxios';
const servicioUsoCfdi = {
    buscarListaUsoCfdi(objeto){
        return instanciaAxios.post("/sinregistro/usocfdi40/obtener_usoscfdi_por_rfc.json",objeto);
    },
    buscarListaUsoCfdiRegistro(objeto){
        return instanciaAxios.post('/usocfdi40/obtener_usoscfdi_por_rfc_registro.json',objeto);
    }
}


export default servicioUsoCfdi;